import React, { useEffect, useState } from 'react'
import { Alert } from 'components'
import { AutoComplete, Button } from 'components/Form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { queryClient as qc, affiliationGroups } from 'keys'
import { CreateBatteryStyles } from '../Assessments/Style'
import { getAffiliationsFetch, getLearningGroupFetch } from 'store/middlewares/affiliation.crud'
import { assignTestTakersToLearningGroupFetch } from 'store/middlewares/testTakers.crud'
import { toast } from 'react-toastify'
import { toastConfig, secretStorage } from 'config'

const AssignTestTakersToLearningGroupAlert = (props) => {
    const { handleAlert = () => { }, onAssigned = () => { }, selectedTestTakerIds } = props
    const queryClient = useQueryClient()

    const { roleIndex } = useSelector(state => state.user)
    const { user_data } = secretStorage.getItem("user") || {}
    const { affiliation_groups } = user_data?.[roleIndex]?.user_data || {}
    const learningCenterGroup = affiliation_groups?.find(group => group.name === affiliationGroups.learningCenters)

    const [learningCenter, setLearningCenter] = useState(null)
    const [learningGroup, setLearningGroup] = useState(null)

    useEffect(() => {
        setLearningGroup(null)
    }, [learningCenter])

    const learningCenters = useQuery({
        queryKey: [qc.learningCenters, learningCenterGroup?.id],
        queryFn: async () => {
            const { data } = await getAffiliationsFetch({ group: learningCenterGroup, page: 1, pageSize: 1000 })
            return data?.results
        },
        enabled: !!learningCenterGroup?.id
    })

    const learningGroups = useQuery({
        queryKey: [qc.learningGroupsForAffiliation, learningCenter?.id],
        queryFn: async () => {
            const { data } = await getLearningGroupFetch(learningCenter.id)
            return data
        },
        enabled: !!learningCenter?.id
    })

    const { mutateAsync: assignTestTakersToLearningGroup, isPending } = useMutation({
        mutationFn: assignTestTakersToLearningGroupFetch,
        onSuccess: () => {
            handleAlert(false)
            onAssigned()
            queryClient.invalidateQueries({ queryKey: [qc.getWithLastAssessments] })
            toast(" העדכון בוצע בהצלחה", toastConfig)
        }
    })

    const handleAssign = () => {
        if (!learningCenter || !learningGroup) {
            toast.error('בחר מרכז למידה וקבוצת למידה', toastConfig)
            return
        }
        assignTestTakersToLearningGroup({ test_taker_ids: selectedTestTakerIds, learning_group_id: learningGroup.id })
    }

    return (
        <Alert
            systemUI
            title={"שיוך תלמידים לקבוצות למידה"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <AutoComplete
                    input={{
                        value: learningCenter,
                        onChange: setLearningCenter
                    }}
                    placeholder="בחר מרכז למידה"
                    options={learningCenters.data}
                />
                <AutoComplete
                    input={{
                        value: learningGroup,
                        onChange: setLearningGroup
                    }}
                    placeholder="בחר קבוצת למידה"
                    options={learningGroups.data}
                    disabled={!learningCenter}
                />
                <div>
                    <Button
                        loading={isPending}
                        disabled={!learningCenter || !learningGroup || isPending}
                        action={handleAssign}
                        color="thirdly"
                        label="שייך את התלמידים שנבחרו לקבוצת הלמידה"
                    />
                </div>
            </CreateBatteryStyles>
        </Alert>
    )
}

export default AssignTestTakersToLearningGroupAlert
